import { useState, type ReactNode } from "react";
import "@/styles/roc-v3.css";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { MobileCta } from "./MobileCta";
import type { Lang } from "./primitives";

/**
 * Envoltorio compartido de la dirección luminosa: cabecera, contenido, pie y
 * CTA móvil. No emite metadatos: cada página conserva su propio SEOWrapper,
 * canonical, hreflang y entidades.
 */
export const SiteShell = ({
  children,
  language = "es",
  altUrl,
  mobileCta = true,
}: {
  children: ReactNode;
  language?: Lang;
  altUrl?: string;
  mobileCta?: boolean;
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="v3-root min-h-screen" data-mobile-cta={mobileCta ? "true" : undefined}>
      <a
        href="#v3-main"
        className="v3-micro sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60]"
      >
        {language === "es" ? "Ir al contenido" : "Skip to content"}
      </a>

      <SiteHeader
        open={menuOpen}
        onOpenChange={setMenuOpen}
        language={language}
        altUrl={altUrl}
      />

      <main id="v3-main">{children}</main>

      <SiteFooter language={language} />
      {mobileCta ? <MobileCta menuOpen={menuOpen} language={language} /> : null}
    </div>
  );
};
